/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { ActivateMyUserOnboardingMutationResponse } from "../types/ActivateMyUserOnboarding.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const activateMyUserOnboardingMutationKey = () =>
  [{ url: "/v1/user-onboarding/me/activate" }] as const

export type ActivateMyUserOnboardingMutationKey = ReturnType<
  typeof activateMyUserOnboardingMutationKey
>

/**
 * @description Supplier portal users only. Completes onboarding and stamps Organization.activatedAt/activatedById for the invited org (and the user org when distinct). Idempotent when already completed or orgs already activated.
 * @summary Activate current user onboarding account
 * {@link /v1/user-onboarding/me/activate}
 */
export async function activateMyUserOnboarding(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ActivateMyUserOnboardingMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: `/v1/user-onboarding/me/activate`,
    ...requestConfig,
  })
  return res
}

export function activateMyUserOnboardingMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = activateMyUserOnboardingMutationKey()
  return mutationOptions<
    ResponseConfig<ActivateMyUserOnboardingMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >({
    mutationKey,
    mutationFn: async () => {
      return activateMyUserOnboarding(config)
    },
  })
}

/**
 * @description Supplier portal users only. Completes onboarding and stamps Organization.activatedAt/activatedById for the invited org (and the user org when distinct). Idempotent when already completed or orgs already activated.
 * @summary Activate current user onboarding account
 * {@link /v1/user-onboarding/me/activate}
 */
export function useActivateMyUserOnboarding<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ActivateMyUserOnboardingMutationResponse>,
      ResponseErrorConfig<Error>,
      void,
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? activateMyUserOnboardingMutationKey()

  const baseOptions = activateMyUserOnboardingMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ActivateMyUserOnboardingMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >

  return useMutation<
    ResponseConfig<ActivateMyUserOnboardingMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ActivateMyUserOnboardingMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >
}
